import { FC } from 'react'

import styles from './step-table.module.scss'

export interface IStep {
  id: number
  title: string
  description: string
}

const Step: FC<IStep> = ({ id, title, description }) => {
  return (
    <li className={styles.educationItem}>
      <div className={styles.educationItemStep}>
        <p className={styles.educationItemNum}>{id}</p>
        <p className={styles.educationItemTitle}>{title}</p>
      </div>
      <p className={styles.educationDesc}>{description}</p>
    </li>
  )
}

export default Step
